import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import * as Constants from 'src/constants';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='Ryan Hill' dateTime='2023-04-18' tag='Policy' title='Buyer Protections'>
        <p>To make buying on OneShop simple and safe, we have policies in place for each purchase:</p>
        <h3>Shipping Guarantees</h3>
        <ul>
          <li>Sellers have 3 business days to ship all orders, excluding US bank holidays.</li>
          <li>If a seller cannot ship on time, you will be awarded a $10 courtesy credit.</li>
          <li>Tracking and shipping insurance are included on all orders.</li>
          <li>For orders above $300, a signature on delivery, or explicit waiver through the carrier, is required.</li>
        </ul>
        <p>
          Details information can be found on our <a href='/policies/shipping-options'>Shipping Options page</a>.
        </p>
        <h3>Returns and Refunds</h3>
        <ul>
          <li>
            Within 24 hours of delivery, OneShop requests a video unboxing of the order sent to{' '}
            <a href='mailto:unboxing@oneshop.com' target='_blank'>
              unboxing@oneshop.com
            </a>
            .
          </li>
          <li>
            Orders without unboxing videos are <b>ineligible</b> for returns or disputes.
          </li>
          <li>
            Orders with valid unboxing videos that do not match their listing description can be submitted to support to
            begin a refund claim.
          </li>
          <li>
            We don't handle authentication. For more info, see our{' '}
            <a style={{ color: Constants.BrandColor.Bolt }} href='/policies/item-authentication'>
              authentication policy
            </a>
            .
          </li>
          <li>
            Approved returns will be sent a shipping label and must be shipped back to the seller in full within 24
            hours of receiving the prepaid label.
          </li>
          <li>A full refund will be issued once final redelivery of all items is confirmed by the original seller.</li>
        </ul>
        <h3>Canceling Orders</h3>
        <ul>
          <li>All orders are final and cannot be canceled.</li>
          <li>
            Orders that the seller does not fulfill will be resolved via the OneShop team. If it has been 3 business
            days, please reach out to <a href='/contact'>OneShop support</a>.
          </li>
        </ul>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
